import React from 'react'
import { connect } from 'react-redux'
import Chat from './Chat'

class Chats extends React.Component {

	render () {
        const percent_altered = (this.props.feedback.prompts && this.props.feedback.prompts.length > 0) ? this.props.feedback.prompts[0].percent_altered : 0;
        // If the AI response has more than 10% of its text changed, consider it not used
        let edited_indicator = '';
        // If the AI response has less than 50% of its text changed, consider it edited
        if (percent_altered <= 50) {
            edited_indicator = ' (AI Generated - Edited)'
        }
        // If the AI response has less than 2% of its text changed, consider it unedited (to account for possible changes in whitespaces)
        if (percent_altered < 2) {
            edited_indicator = ' (AI Generated - Unedited)'
        }
        // Catch null values
        if (percent_altered === null) {
            edited_indicator = ''
        }

		let chats = this.props.feedback.chats;
        let firstNonAutoResponseChatIndex = this.props.feedback.chats.findIndex((c) => c.auto_response === false)
		const chat_messages = chats.map((value,index) =>
  		    <Chat key={index} hidename={this.props.hidename} chat={value} id={value.id} red_alerts_list={this.props.red_alerts_list} edited_indicator={firstNonAutoResponseChatIndex === index ? edited_indicator : ''} />
		);
		return (
		<div className="chat_widget_body">
			{chat_messages}
		</div>
		);
	}
}

function mapStateToProps(state) {
	return { feedback:state.feedback_detail, red_alerts:state.red_alerts??null, red_alerts_list:state.red_alerts_list??null }
}

export default connect(mapStateToProps)(Chats)
